module.exports = __webpack_public_path__ + "img/CS2_section_4_inside_carriage-01.0ee4dd55.png";